import { render, staticRenderFns } from "./SegmentationFixedSize.vue?vue&type=template&id=a221bdd0"
import script from "./SegmentationFixedSize.vue?vue&type=script&lang=js"
export * from "./SegmentationFixedSize.vue?vue&type=script&lang=js"
import style0 from "./SegmentationFixedSize.vue?vue&type=style&index=0&id=a221bdd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports